import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useCustomer from "common/datahooks/useCustomer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useMembersMutations from "../datahooks/useMembersMutations";

interface RemoveMemberProps {
  memberCustomerId: string;
  email: string;
  onBack: () => void;
}

export default function RemoveMember({
  memberCustomerId,
  email,
  onBack,
}: RemoveMemberProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { name: workspaceName } = useSelectedWorkspaceContext();
  const {
    customerInfo: { email: customerEmail },
  } = useCustomer();

  const { removeMember, leaveWorkspace, isRemovingMember, isLeavingWorkspace } =
    useMembersMutations();

  const isLoading = isRemovingMember || isLeavingWorkspace;
  const isCustomerMember = customerEmail === email;

  function handleRemoveClick() {
    if (customerEmail === email) {
      leaveWorkspace({ memberId: memberCustomerId });
      return;
    }

    removeMember({ memberId: memberCustomerId });
  }
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={
          isCustomerMember
            ? "Are you sure you want to leave this workspace?"
            : "Remove from workspace?"
        }
        subtitle={
          isCustomerMember ? (
            "You will no longer be able to access this workspace or any data related to it"
          ) : (
            <>
              Are you sure you want to remove{" "}
              <span className="font-semibold text-black-950">
                &apos;{email}&apos;{" "}
              </span>
              from {workspaceName}
            </>
          )
        }
      />

      <Footer className="justify-end">
        <Button variant="secondary-black" disabled={isLoading} onClick={onBack}>
          Cancel
        </Button>

        <Close asChild>
          <Button
            variant="outline-danger"
            isLoading={isLoading}
            onClick={handleRemoveClick}
          >
            {isCustomerMember ? "Leave workspace" : "Remove"}
          </Button>
        </Close>
      </Footer>
    </>
  );
}
